module.exports = __webpack_public_path__ + "media/videos/autopilot/autopilot-preview-153b8609f7cfa5f3a898a690a0c07d22.mp4";